<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
            <!-- <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/enrolment/create-course"><i class="fas fa-plus"></i> {{ "CREATE_COURSE" | translate |
                titlecase }}</button> -->
        </div>

        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "LECTURE_SCHEDULE" | translate | titlecase }}</h5>
                <br>
                <app-loader ></app-loader>

                <!-- <div style="text-align: center;font-size: 16px;font-weight: bold;" *ngIf="false">Show message here if enrollment is finilizes</div> -->
                <div class="col-12" >
                    
                    <br>
                    <h5 class="font-16 font-black px-3">{{ "SSIGN_SUBJECT" | translate | titlecase }}</h5>

                    <!-- <app-loader [show]="loadingStudentRepeater"></app-loader> -->
                    <div class="table-responsive py-3" >
                        <table class="table-striped" id="datatable">
                            <thead>
                                <tr>
                                    <th>{{ "DAY" | translate | titlecase }}</th>
                                    <th>{{ "SLOT_ID" | translate | titlecase }}</th>
                                    <th>{{ "START_TIME" | translate | titlecase }}</th>
                                    <th>{{ "END_TIME" | translate | titlecase }}</th>
                                    <th>{{ "GROUP_SUBJECT" | translate | titlecase }}</th>
    
                                    <th>{{ "LECTURER" | translate | titlecase }}</th>
                                    

                                    <th class="border-0 font-14 px-2 text-grey"></th>
                                    <!-- <th class="border-0 font-14 px-2 text-grey" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">{{ "COURSE_MODIFY" | translate | titlecase }}</th> -->
                                </tr>
                                <tr>
                                    <td>
                                        <div class="form-group">
                                            <select class="form-control custom-select">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let element of workingDaysData" value="{{element.item_id}}">
                                                    {{element.item_text}}
                                                    <!-- {{(globals.lang == 'ar')? element.subjectNameAr : element.subjectNameEn}} -->
                                                </option>
                                            </select>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <select class="form-control custom-select">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let element of workingDaysData" value="{{element.item_id}}">
                                                    {{element.item_text}}
                                                    <!-- {{(globals.lang == 'ar')? element.subjectNameAr : element.subjectNameEn}} -->
                                                </option>
                                            </select>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <input type="text" class="form-control" value="8:30" readonly>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <input type="text" class="form-control" value="9:30" readonly>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <select class="form-control custom-select">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let element of workingDaysData" value="{{element.item_id}}">
                                                    {{element.item_text}}
                                                    <!-- {{(globals.lang == 'ar')? element.subjectNameAr : element.subjectNameEn}} -->
                                                </option>
                                            </select>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <select class="form-control custom-select">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let element of workingDaysData" value="{{element.item_id}}">
                                                    {{element.item_text}}
                                                    <!-- {{(globals.lang == 'ar')? element.subjectNameAr : element.subjectNameEn}} -->
                                                </option>
                                            </select>
                                        </div>
                                    </td>
                                    <td class="text-bold text-success">
                                        <a class="btn btn-sm btn-link text-success" (click)="addSlotSubject()">
                                            <i class="fas fa-plus"></i>
                                            {{ "ADD" | translate | titlecase }}</a>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let res of slots let i = index">
                                    <td>{{res?.day}}</td>
                                    <td>{{res?.slotID}}</td>
                                    <td>{{res?.startTime}}</td>
                                    <td>{{res?.endTime}}</td>
                                    <td>{{res?.subject}}</td>
                                    <td>{{res?.lecturer}}</td>
    
                                    <td class="text-bold text-warning">
                                        <a class="btn btn-sm btn-link text-warning" (click)="updateCurrentSlotId(res?.id)" data-toggle="modal"
                                        data-target="#deleteRepeaterModal">
                                            <i class="fas fa-trash"></i>
                                            {{ "REMOVE" | translate | titlecase }}</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- <div class="row">
                        <div class="col-md-4 form-group px-md-5 mb-4" style="margin: auto;text-align: center;">
                            <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0" (click)="addStudentRepeaters()"> {{ "SUBMIT" | translate |
                                titlecase }}
                            </button>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteRepeaterModal" tabindex="-1" aria-labelledby="deleteRepeaterModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <!-- <i class="fas fa-trash text-danger"></i> -->
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b> </div>

                <a type="button" class="btn btn-link text-danger" (click)="removeSlotLec()"
                    data-dismiss="modal">{{ "YES"
                    | translate | titlecase }}</a>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>